import { computed, makeObservable } from 'mobx'
import Document from 'documents/Document'
import { DocumentActionsAdapter } from 'documents/DocumentActionsAdapter'
import WorkpapersFormViewModel from './WorkpapersForm/WorkpapersFormViewModel'
import WorkpapersPreviewerViewModel from './WorkpapersPreviewer/WorkpapersPreviewerViewModel'
import { task } from 'mobx-task'

export default class WorkpapersViewModel {
  formVM = new WorkpapersFormViewModel(this.document, this.adapter)

  previewerVM = new WorkpapersPreviewerViewModel(this.document, this.adapter)

  constructor(
    private document: Document,
    private adapter: DocumentActionsAdapter
  ) {
    makeObservable(this, {
      id: computed,
      isValidated: computed,
      hasValidFields: computed,
    })
  }

  get id() {
    return this.document.id
  }

  get title() {
    return this.document.title
  }

  get isValidated() {
    return this.document.extractionState === 'Validated'
  }

  get extractionState() {
    if (
      !this.document.extractionState ||
      this.document.extractionState === 'Aborted'
    ) {
      return 'Unavailable'
    }

    return this.document.extractionState
  }

  get hasValidFields() {
    return this.formVM.isValid
  }

  validateFields = task.resolved(async () => {
    await this.formVM.submit()
  })

  download() {
    this.adapter.downloadDocument(this.document)
  }

  toCsvRows() {
    return this.document.fields.map((field) => [
      this.document.id,
      this.document.type?.name.toString(),
      field.schemaId,
      field.id,
      field.type === 'DATE'
        ? field.value?.toISOString()
        : field.value?.toString(),
      field.corrected ? 'Yes' : 'No',
    ])
  }

  activate() {
    this.formVM.activate()
    this.previewerVM.activate()
  }

  deactivate() {
    this.formVM.deactivate()
    this.previewerVM.deactivate()
  }
}
